var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"frame",staticClass:"iframe-container",attrs:{"data-src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }